import styled, { css } from 'styled-components';
import theme from 'src/theme';

export interface IButtonProps {
    isSelected?: boolean;
    disabled?: boolean;
    altColor?: boolean;
    onClick?: (eventTypeId: number) => void;
}

export interface IPositionProps {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
}

export interface IPanelProps {
    alignLeft?: boolean;
    alignCenter?: boolean;
}

// ============================================
// Button Components
// ============================================

/**
 * IconButton - For icon-only buttons (filters, actions, etc.)
 * Usage: <IconButton><FontAwesomeIcon icon="filter" /></IconButton>
 */
export const IconButton = styled.button<IButtonProps>`
    color: ${(props) => (props.altColor ? '#fff' : theme.colors.text.primary)};
    background: transparent;
    border: 1px solid transparent;
    font-size: 1rem;
    cursor: pointer;
    padding: 3px 6px;
    border-radius: 3px;
    transition: all 0.2s ease;
    
    &:hover {
        background: ${theme.colors.background.hover.default};
        border: 1px solid ${theme.colors.border.primary};
    }
    
    ${({ isSelected }) =>
        isSelected &&
        css`
            background: ${theme.colors.background.selected};
            border: 1px solid ${theme.colors.border.selected};
            color: ${theme.colors.text.heading};
        `}
        
    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
            opacity: 0.6;
        `}
`;

/**
 * TextButton - For text-based action buttons like "Copy last ROB", "Save", etc.
 * Based on OrcaWebsite TabLineButton pattern (ChemicalRobHeader.tsx)
 * Usage: <TextButton onClick={handleCopy}>Copy last ROB</TextButton>
 */
export const TextButton = styled.button<IButtonProps>`
    cursor: pointer;
    text-align: center;
    display: inline-block;
    font-size: 0.75rem;
    font-weight: 600;
    height: 30px;
    padding: 0 10px;
    border-radius: 4px;
    background: ${theme.colors.background.darkBlue};
    color: ${theme.colors.text.white};
    border: 1px solid ${theme.colors.border.primary};
    box-shadow: 0 1px 10px -2px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
    
    &:hover {
        opacity: 0.9;
    }
    
    ${({ isSelected }) =>
        isSelected &&
        css`
            background: ${theme.colors.background.selected};
            border: 1px solid ${theme.colors.border.selected};
            color: ${theme.colors.text.heading};
        `}
        
    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
            opacity: 0.6;
            &:hover {
                opacity: 0.6;
            }
        `}
`;